module.exports = __webpack_public_path__ + "img/logo_login.5626ef1d.png";